import './tab-content.css';
export default {
  "modifiers": {
    "light_300": "pf-m-light-300",
    "padding": "pf-m-padding"
  },
  "tabContent": "pf-v5-c-tab-content",
  "tabContentBody": "pf-v5-c-tab-content__body"
};